import type { BuyerTest } from '../../../lib/aiJobSummary';
import { Badge } from '../../ui';
import SectionHeading, { OpCard } from './SectionHeading';

const label: React.CSSProperties = { fontSize: 'var(--text-xs)', color: 'var(--text-faint)', whiteSpace: 'nowrap' };

/** Page Build jobs: the cold read of the preview as the buyer, before the SEO review. */
export default function BuyerTestCard({ test }: { test: BuyerTest }) {
  return (
    <section>
      <SectionHeading
        eyebrow="Buyer test · a fresh agent reads the preview cold, as the buyer"
        title={test.passed ? 'Passes the five-second test' : test.rounds && test.rounds >= 3 ? `Still failing after ${test.rounds} rounds: your call` : 'Fails the five-second test'}
        icon="user"
        actions={
          <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
            <Badge tone={test.passed ? 'up' : 'down'}>{test.passed ? 'pass' : 'fail'}</Badge>
            {test.rounds && test.rounds > 1 ? <Badge tone="neutral">{test.rounds} rounds</Badge> : null}
          </div>
        }
      />
      <OpCard tone="raised">
        <div style={{ display: 'grid', gridTemplateColumns: 'auto minmax(0, 1fr)', gap: '8px 16px', fontSize: 'var(--text-sm)' }}>
          <span style={label}>What this is</span>
          <span>{test.what_it_is}</span>
          <span style={label}>Who it's for</span>
          <span>{test.for_whom}</span>
          <span style={label}>What I'd do next</span>
          <span>{test.next_step}</span>
          <span style={label}>Would make me leave</span>
          <span style={{ color: 'var(--text-muted)' }}>{test.would_leave.length ? test.would_leave.join(' · ') : 'Nothing'}</span>
        </div>
      </OpCard>
    </section>
  );
}
